<style src="./style.scss">
</style>

<script lang="ts">
  import { afterUpdate } from "svelte";

  import Button from "@components/button";
  import Badge from "@components/badge";

  import Feature1 from "@assets/images/unsubscribe/feature-1.png";
  import Feature2 from "@assets/images/unsubscribe/feature-2.png";
  import Feature3 from "@assets/images/unsubscribe/feature-3.png";
  import Feature4 from "@assets/images/unsubscribe/feature-4.png";
  import Feature5 from "@assets/images/unsubscribe/feature-5.png";
  import Feature6 from "@assets/images/unsubscribe/feature-6.png";
  import Feature7 from "@assets/images/unsubscribe/feature-7.png";
  import Feature8 from "@assets/images/unsubscribe/feature-8.png";
  import Feature9 from "@assets/images/unsubscribe/feature-9.png";

  export let goBack = () => null;
  export let nextStep = () => null;
  export let nextPaymentRemainingDays = null;
</script>

<h1>Você tem certeza que deseja cancelar a sua assinatura?</h1>

<div class="unsubscribe__features">
  <p>
    Você tem <b>{nextPaymentRemainingDays} dias</b> restantes para aproveitar seus
    benefícios no CNA Go até a próxima cobrança.
  </p>

  <div class="unsubscribe__features__items">
    <div class="unsubscribe__features__items__item">
      <div class="unsubscribe__features__items__item__image">
        <img src="{Feature1}" />
        <Badge title="Plano gold" background="#ffae00" />
      </div>
      <div class="unsubscribe__features__items__item__title">
        Aulas de conversação
      </div>
      <div class="unsubscribe__features__items__item__description">
        Aulas de conversação ao vivo com grupos de até 15 alunos
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature2}" />
      <div class="unsubscribe__features__items__item__title">
        Videoaulas para  todos os níveis
      </div>
      <div class="unsubscribe__features__items__item__description">
        115 aulas em vídeo + 7.000 atividades no app CNA Go
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature3}" />
      <div class="unsubscribe__features__items__item__title">
        Chat com professores bilíngues
      </div>
      <div class="unsubscribe__features__items__item__description">
        Sessões particulares ilimitadas pelo chat com professores bilíngues
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature4}" />
      <div class="unsubscribe__features__items__item__title">
        Lives com professores bilíngues
      </div>
      <div class="unsubscribe__features__items__item__description">
        Lives com professores bilíngues simulando situações reais
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature5}" />
      <div class="unsubscribe__features__items__item__title">
        Superclasses  temáticas
      </div>
      <div class="unsubscribe__features__items__item__description">
        Aulões temáticos com o vocabulário dos temas que você mais gosta
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature6}" />
      <div class="unsubscribe__features__items__item__title">
        Certificado de  conclusão
      </div>
      <div class="unsubscribe__features__items__item__description">
        Certificado de conclusão no idioma baseado em desafios  do app
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature7}" />
      <div class="unsubscribe__features__items__item__title">
        Material didático dentro do app
      </div>
      <div class="unsubscribe__features__items__item__description">
        Material didático digital exclusivo CNA Go
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature8}" />
      <div class="unsubscribe__features__items__item__title">
        Metodologia comprovada
      </div>
      <div class="unsubscribe__features__items__item__description">
        Communicative language teaching e Learning distributed practice
      </div>
    </div>

    <div class="unsubscribe__features__items__item">
      <img src="{Feature9}" />
      <div class="unsubscribe__features__items__item__title">
        CNA, tradição no ensino de idiomas
      </div>
      <div class="unsubscribe__features__items__item__description">
        Temos mais de 400 mil alunos e 600 escolas espalhadas pelo Brasil.
      </div>
    </div>
  </div>
</div>

<div class="unsubscribe__buttons">
  <div>
    <Button title="Manter minha assinatura" onClick="{goBack}" />
      <div>
        <span>
          Você tem <b>{nextPaymentRemainingDays} dias restantes</b> para aproveitar seus benefícios
          no CNA Go até a próxima cobrança.
        </span>
      </div>
  </div>
  <div>
    <Button title="Continuar" type="secondary" onClick="{nextStep}" />
    <div>
      <span>
        <a target="_blank" href="https://cnago.app/termos/"
          >Contrato e Termos de uso CNA Go</a>
      </span>
    </div>
  </div>
</div>
